// @ts-nocheck
import React from 'react';

const SIZES = {
  sm: 'w-7 h-7 rounded-lg2',
  md: 'w-[34px] h-[34px] rounded-md2',
  lg: 'w-9 h-9 rounded-md2',
};

const VARIANTS = {
  default: 'mov-btn-default border border-mov-line-strong bg-mov-paper text-mov-ink-soft hover:text-mov-ink',
  ghost: 'border border-transparent bg-transparent text-mov-ink-mute hover:bg-mov-paper-2 hover:border-mov-line hover:text-mov-ink',
  filled: 'mov-btn-primary',
};

const IconButton = React.forwardRef(({
  icon: Icon,
  size = 'md',
  variant = 'default',
  badge,
  className = '',
  ariaLabel,
  ...rest
}, ref) => (
  <button
    ref={ref}
    type="button"
    aria-label={ariaLabel}
    className={[
      'relative inline-grid place-items-center transition-colors duration-150 outline-none cursor-pointer mov-focus-ring',
      SIZES[size],
      VARIANTS[variant],
      className,
    ].join(' ')}
    {...rest}
  >
    {Icon && <Icon size={size === 'sm' ? 13 : 15} />}
    {badge && (
      <span
        className="absolute"
        style={{
          top: 6, right: 6,
          width: 7, height: 7, borderRadius: '50%',
          background: 'var(--mov-warn)',
          boxShadow: '0 0 0 1.5px var(--mov-paper)',
        }}
      />
    )}
  </button>
));
IconButton.displayName = 'IconButton';

export default IconButton;
